import { useEffect, useState } from "react"
import { Circle, MapContainer, Polyline, TileLayer, Tooltip } from "react-leaflet";
import L from 'leaflet';
import { FehlerauswertungErrResp } from "../../Fehler/FehlerauswertungErrResp";
import styled from "styled-components";


var MonitorApi = require('monitor-api');

export default function InfraMap({ bhfInstance, strInstance, strVerlInstance, linInstance, linVerlInstance }) {

    const [bhfse, setBhfse] = useState({
        'von': undefined,
        'nach': undefined
    });
    const [bhfList, setBhfList] = useState([]);
    const [possibleNextBhf, setPossibleNextBhf] = useState([]);
    const [infraChecks, setInfraChecks] = useState({});
    const [availableInfras, setAvailableInfras] = useState([]);
    const [showLabel, setShowLabel] = useState(true);

    const [linienListe, setLinienListe] = useState([]);
    const [chosenLinie, setChosenLinie] = useState();
    const [existentInfras, setExistentInfras] = useState([]);
    const [existentInfrasChecksHr, setExistentInfrasChecksHr] = useState({});
    const [existentInfrasChecksRr, setExistentInfrasChecksRr] = useState({});

    const colorList = ['darkred', 'sandybrown', 'gold', 'lawngreen', 'green', 'turquoise', 'dodgerblue', 'mediumblue', 'darkorchid', 'deeppink', 'black'];
    const [streckenColor, setStreckenColor] = useState({});

    useEffect(() => {
        bhfInstance.getListOfBahnhofsBahnhoflisteGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setBhfList(data);
            }
        })
    }, [bhfInstance]);

    useEffect(() => {
        linInstance.getLinieLinieGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setLinienListe(data);
            }
        })
    }, [linInstance]);

    const getPossibleEnd = (idStartBhf) => {
        strInstance.getPossibleEnds(idStartBhf, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                setPossibleNextBhf(data);
            }
        })
    }

    const selectBhf = event => {
        event.preventDefault();
        if (event.target.id === "von") {
            getPossibleEnd(event.target.value);
        }
        setBhfse(pre => ({ ...pre, [event.target.id]: event.target.value }));
    }

    function handleStreckenLoad(data) {
        console.log(data);
        setInfraChecks({});
        setStreckenColor({});
        data.forEach(it =>
            setInfraChecks(pre => ({ ...pre, [it.id_strecke]: false }))
        );
        setAvailableInfras(data);
        data.forEach((infra, index) => {
            setStreckenColor(pre => ({ ...pre, [infra.id_strecke]: colorList[index] }));
        }
        );
    }

    function infraSuchen(event) {
        event.preventDefault();
        var startEnd = new MonitorApi.StreckeVonBis();
        startEnd.id_eins = bhfse.von;
        startEnd.id_zwei = bhfse.nach;
        strVerlInstance.searchStreckenverlaufWithCoords(startEnd, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                handleStreckenLoad(data);
            }
        })
    }

    function chooseInfra(event) {
        setInfraChecks(pre => ({ ...pre, [event.target.id]: event.target.checked }))
    }

    function resetVarianteEins(event) {
        event.preventDefault();
        setAvailableInfras([]);
        setBhfse({});
        setPossibleNextBhf([]);
    }

    function selectLinie(event) {
        event.preventDefault();
        setStreckenColor({});
        setExistentInfrasChecksHr({});
        setExistentInfrasChecksRr({});
        setChosenLinie(event.target.value);
        linVerlInstance.getLinienverlaufCoords(event.target.value, (error, data, response) => {
            if (error) {
                FehlerauswertungErrResp(error, response);
            } else {
                data.forEach(element => {
                    if (element.gueltig_von) {
                        element.gueltig_von = element.gueltig_von.toLocaleDateString();
                    }
                    if (element.gueltig_bis) {
                        element.gueltig_bis = element.gueltig_bis.toLocaleDateString();
                    }
                    setExistentInfrasChecksHr(pre => ({ ...pre, [element.id]: false }));
                    setExistentInfrasChecksRr(pre => ({ ...pre, [element.id]: false }));
                });
                setExistentInfras(data);
                data.forEach((infra, index) => {
                    setStreckenColor(pre => ({ ...pre, [infra.id]: colorList[index] }));
                }
                );
            }
        })
    }

    function resetVarianteZwei(event) {
        event.preventDefault();
        setStreckenColor({});
        setExistentInfrasChecksHr({});
        setExistentInfrasChecksRr({});
        setChosenLinie();
    }

    return (
        <div>
            <BeideVarianten>
                <Variante>
                    <VarianteHeader>Variante 1</VarianteHeader>
                    <VarianteBeschreibung>Auswahl von Start- und Endbahnhof zum Laden allter registrierten Infrastrukturen.</VarianteBeschreibung>
                    <label>
                        <input type="checkbox" checked={showLabel} onChange={e => setShowLabel(e.target.checked)} />
                        Bahnhofsnamen anzeigen
                    </label>
                    <VarianteContent>
                        <form onSubmit={infraSuchen}>
                            <label>von:
                                <VarianteSelect id="von" onChange={selectBhf} required>
                                    <option id={0} key={0} value="" defaultValue hidden>---Bahnhof wählen---</option>
                                    {bhfList.map(bhf =>
                                        <option key={bhf.id} value={bhf.id}>{bhf.bahnhof}</option>
                                    )}
                                </VarianteSelect>
                            </label>
                            <label>nach:
                                <VarianteSelect id="nach" onChange={selectBhf} required>
                                    <option id={0} key={0} value="" defaultValue hidden>---Bahnhof wählen---</option>
                                    {possibleNextBhf.map(bhf =>
                                        <option key={bhf.id} value={bhf.id}>{bhf.bahnhof}</option>
                                    )}
                                </VarianteSelect>
                            </label>
                            <button type="submit">Suchen</button>
                        </form>
                        <ul type="none">
                            {availableInfras.map((infra, index) => {
                                return (
                                    <li>
                                        <label key={infra.id_strecke}>
                                            <span style={{ 'color': `${streckenColor[infra.id_strecke]}`, 'fontWeight': 'bold' }}>{index + 1}: </span>
                                            <input type="checkbox" id={infra.id_strecke} key={infra.id_strecke} checked={infraChecks[infra.id_strecke]} value="sth" onChange={chooseInfra} />
                                            mit {infra.strecke.length} Bahnhöfen
                                        </label>
                                    </li>
                                )
                            })}
                        </ul>
                    </VarianteContent>
                    <div>
                        <button onClick={resetVarianteEins}>Reset</button>
                    </div>
                </Variante>
                <Variante>
                    <VarianteHeader>Variante 2</VarianteHeader>
                    <VarianteBeschreibung >Auswahl einer Linie ermöglicht Anzeigen aller eingetragenen Strecken, getrennt nach Hin- und Rückrichtung.</VarianteBeschreibung>
                    <label>
                        <input type="checkbox" checked={showLabel} onChange={e => setShowLabel(e.target.checked)} />
                        Bahnhofsnamen anzeigen
                    </label>
                    <VarianteContent >
                        <label>Linie auswählen:
                            <select onChange={selectLinie} style={{ 'margin': '0.5em' }}>
                                <option id={0} key={0} defaultValue hidden>---Linie wählen---</option>
                                {linienListe.map(linie =>
                                    <option key={linie.id} value={linie.id}>{linie.linie} ( {linie.vm} {linie.kommentar})</option>
                                )}
                            </select>
                        </label>
                        {
                            chosenLinie && <><table style={{ marginTop: '1em' }}>
                                <thead><tr>
                                    <th></th>
                                    <th>Gültigkeit</th>
                                    <th>Hinrichtung</th>
                                    <th>Rückrichtung</th>
                                </tr></thead>
                                <tbody>
                                    {existentInfras.map((infra, index) =>
                                        <tr>
                                            <td style={{ 'color': `${streckenColor[infra.id]}`, 'fontWeight': 'bold' }}>{index + 1}:</td>
                                            <td style={{ textAlign: 'center' }}>{infra.gueltig_von} - {infra.gueltig_bis}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                <input type="checkbox" key={infra.id}
                                                    checked={existentInfrasChecksHr[infra.id]}
                                                    onChange={e => setExistentInfrasChecksHr(pre => ({ ...pre, [infra.id]: e.target.checked }))}
                                                />
                                            </td>
                                            <td style={{ textAlign: 'center' }}>{infra.id_strecke_hr === infra.id_strecke_rr ? '' :
                                                <input type="checkbox" key={infra.id}
                                                    checked={existentInfrasChecksRr[infra.id]}
                                                    onChange={e => setExistentInfrasChecksRr(pre => ({ ...pre, [infra.id]: e.target.checked }))}
                                                />
                                            }</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            </>
                        }
                        {/* <p>{JSON.stringify(existentInfrasChecksHr)}</p>
                    <p>{JSON.stringify(existentInfrasChecksRr)}</p>
                    <p>{JSON.stringify(streckenColor)}</p> */}
                    </VarianteContent>
                    <div>
                        <button onClick={resetVarianteZwei}>Reset</button>
                    </div>
                </Variante>
            </BeideVarianten>
            {showLabel ?
                <Karte chosenInfra={availableInfras.filter(it => infraChecks[it.id_strecke])}
                    chosenHrThings={existentInfras.filter(it => existentInfrasChecksHr[it.id])}
                    chosenRrThings={existentInfras.filter(it => existentInfrasChecksRr[it.id])}
                    showLabel={true}
                    color={streckenColor}
                /> :
                <Karte chosenInfra={availableInfras.filter(it => infraChecks[it.id_strecke])}
                    chosenHrThings={existentInfras.filter(it => existentInfrasChecksHr[it.id])}
                    chosenRrThings={existentInfras.filter(it => existentInfrasChecksRr[it.id])}
                    showLabel={false}
                    color={streckenColor}
                />
            }
        </div>
    )
}

function Karte({ chosenInfra, showLabel, chosenHrThings, chosenRrThings, color }) {
    return (
        <div className="map-linien-bhf">
            <MapContainer center={[50.929472, 13.458333]} zoom={8} scrollWheelZoom={true} style={{ width: "100%", height: "100%" }} >
                <TileLayer
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {chosenInfra.length > 0 && <>
                    <CreatePaths chosenInfra={chosenInfra} radius={100} showLabel={showLabel} />
                    <DrawPath chosenInfra={chosenInfra} color={color} />
                </>}
                {chosenHrThings.length > 0 && <>
                    <CreatePathsLinieHr chosenInfra={chosenHrThings} radius={100} showLabel={showLabel} />
                    <DrawPathLinieHr chosenInfra={chosenHrThings} color={color} />
                </>}
                {chosenRrThings.length > 0 && <>
                    <CreatePathsLinieRr chosenInfra={chosenRrThings} radius={100} showLabel={showLabel} />
                    <DrawPathLinieRr chosenInfra={chosenRrThings} color={color} />
                </>}
            </MapContainer>
        </div>
    )
}

function CreatePaths({ chosenInfra, radius, showLabel }) {
    return (
        <div>
            {chosenInfra.map(infra =>
                infra.strecke.map(bhf =>
                    ({ coords: L.latLng(bhf.ycoord, bhf.xcoord), id: bhf.id_bhf, pos: bhf.pos, bhf: bhf.bhf }))
                    .map(data =>
                        <CreateCircle coords={data.coords} key={`${data.id}-${data.pos}`} radius={radius} bhf={data.bhf} showLabel={showLabel} fillColor='rgba(205, 50, 120, 0.05)' color="rgba(205, 50, 120)" />))}

        </div>
    )
}

function CreateCircle({ coords, radius, bhf, fillColor, color, showLabel }) {
    return (
        <Circle center={coords} pathOptions={{ width: "1", fillColor: fillColor, color: color }} radius={radius} metric={true} >
            <Tooltip permanent={showLabel}>{bhf}</Tooltip>
        </Circle>
    )
}

function DrawPath({ chosenInfra, color }) {
    return (
        <div>
            {chosenInfra.map(infra => (
                {
                    'id': infra.id_strecke,
                    'pos': infra.strecke.map(bhf => L.latLng(bhf.ycoord, bhf.xcoord))
                }
            ))
                .map(d =>
                    <Polyline pathOptions={{ color: color[d.id] }} positions={d.pos} key={`${d.id}`}>
                        {/* <Tooltip>Strecke: {index + 1}</Tooltip> */}
                    </Polyline>)
            }
        </div>
    )
}

function DrawPathLinieHr({ chosenInfra, color }) {
    return (
        <div>
            {chosenInfra.map(verlauf => (
                {
                    'id': verlauf.id,
                    'pos': verlauf.ext_verlauf_hr.map(bhf => L.latLng(bhf.ycoord, bhf.xcoord))
                }
            ))
                .map(d =>
                    <Polyline pathOptions={{ color: color[d.id] }} positions={d.pos} key={`${d.id}-hr`} >
                        <Tooltip sticky>hin</Tooltip>
                    </Polyline>)
            }
        </div>
    )
}

function DrawPathLinieRr({ chosenInfra, color }) {
    return (
        <div>
            {chosenInfra.map(verlauf => (
                {
                    'id': verlauf.id,
                    'pos': verlauf.ext_verlauf_rr.map(bhf => L.latLng(bhf.ycoord, bhf.xcoord))
                }
            ))
                .map(d =>
                    <Polyline pathOptions={{ color: color[d.id] }} positions={d.pos} key={`${d.id}-rr`} >
                        <Tooltip sticky>rück</Tooltip>
                    </Polyline>)
            }
        </div>
    )
}

function CreatePathsLinieHr({ chosenInfra, radius, showLabel }) {
    return (
        <div>
            {chosenInfra.map(infra =>
                infra.ext_verlauf_hr.map(bhf =>
                    ({ coords: L.latLng(bhf.ycoord, bhf.xcoord), id: bhf.id_bhf, pos: bhf.pos, bhf: bhf.bhf }))
                    .map(data =>
                        <CreateCircleLinie coords={data.coords} key={`${data.id}-${data.pos}`} radius={radius} bhf={data.bhf} showLabel={showLabel} fillColor='rgba(205, 50, 120, 0.05)' color={'rgba(205, 50, 120)'} />))}

        </div>
    )
}

function CreatePathsLinieRr({ chosenInfra, radius, showLabel }) {
    return (
        <div>
            {chosenInfra.map(infra =>
                infra.ext_verlauf_rr.map(bhf =>
                    ({ coords: L.latLng(bhf.ycoord, bhf.xcoord), id: bhf.id_bhf, pos: bhf.pos, bhf: bhf.bhf }))
                    .map(data =>
                        <CreateCircleLinie coords={data.coords} key={`${data.id}-${data.pos}`} radius={radius} bhf={data.bhf} showLabel={showLabel} fillColor='rgba(205, 50, 120, 0.05)' color={'rgba(205, 50, 120)'} />))}

        </div>
    )
}

function CreateCircleLinie({ coords, radius, bhf, fillColor, color, showLabel }) {
    return (
        <Circle center={coords} pathOptions={{ width: "1", fillColor: fillColor, color: color }} radius={radius} metric={true} >
            <Tooltip permanent={showLabel}>{bhf}</Tooltip>
        </Circle>
    )
}

const BeideVarianten = styled.div`
  display: flex;
  padding: 1em;
  width: 80%;
`
const Variante = styled.div`
  margin: 0.75em;
  border: 1px solid darkcyan;
  width: 70%;
  padding: 1em;
`
const VarianteHeader = styled.h4`
    margin-bottom: 0;
`

const VarianteBeschreibung = styled.aside`
margin-bottom: 0.5em;
 font-size: smaller;
`
const VarianteSelect = styled.select`
margin: 0.5em;
`
const VarianteContent = styled.div`
    margin-top: 1em;
  width: fit-content;
   padding': 0.5em ;
`
